var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42.55257mm",
    height: "10mm",
    viewBox: "0 0 42.55257 10",
    id: "svg1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Liked Songs Manager") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.84596,
    y: 281.34763,
    width: 283.26157,
    height: 157.89919,
    id: "rect1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-26.313325,-74.369184)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,0.25974197,-0.79506559)",
    id: "text1",
    style: {
      fontSize: "21.3333px",
      whiteSpace: "pre",
      shapeInside: "url(#rect1)",
      display: "inline",
      fill: "#000000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 136.8457,
    y: 300.81067,
    id: "tspan5"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "currentColor",
    style: {
      fontFamily: "Poppins",
      InkscapeFontSpecification: "Poppins"
    },
    id: "tspan4"
  }, "liked songs"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "4.58611px",
      fill: "#000000",
      strokeWidth: 0.264583
    },
    x: 36.548534,
    y: 82.871193,
    id: "text2"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "currentColor",
    id: "tspan2",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "4.58611px",
      fontFamily: "Poppins",
      InkscapeFontSpecification: "Poppins",
      strokeWidth: 0.264583
    },
    x: 36.548534,
    y: 82.871193
  }, "manager")), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#568d8f",
      fillOpacity: 1,
      strokeWidth: 0.552104
    },
    id: "rect6",
    width: 3.4998112,
    height: 3.4995117,
    x: 26.313324,
    y: 75.496223
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.505624
    },
    id: "rect7",
    width: 3.4998112,
    height: 3.4995117,
    x: 29.813511,
    y: 78.996712
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.662c6706d5e0e82472b7911ff072251e.svg";
export { ForwardRef as ReactComponent };